// B-102 — a pending note "Transacción en vuelo" proposed to the bank: the bank shows fewer
// transactions than the cashier's support, so the operator asks it to load the missing one. The
// email names the office, the concept, the value and the day, with the support attached; the
// operator previews it and approves it (`sendCierrePendingItemNotice`). "Para" empty sends to the
// client's own recipients. Once sent, the note says so (`noticeSentAt`).
import { useState } from "react";
import { Button, Spinner } from "@mantis-sas/ui";

import { sendCierrePendingItemNotice } from "../../../ApiCalls/mantisBusiness";
import { correctionError } from "../../../utils/cierreCorrections";
import { montoEscrito } from "../../../utils/cierreCuadreDia";

const CAMPO = "mt-1 block w-full rounded-[6px] border px-2 py-1";

export function CorreoTxEnVuelo({ token, mantisBusinessId, clientCode, item, onEnviado, onCancelar }) {
  const [concepto, setConcepto] = useState("");
  const [valor, setValor] = useState(String(Math.abs(Number(item.amount))).replace(".", ","));
  const [para, setPara] = useState("");
  const [comentario, setComentario] = useState("");
  const [soporte, setSoporte] = useState(null);
  const [vista, setVista] = useState(null);
  const [trabajando, setTrabajando] = useState(false);
  const [error, setError] = useState("");

  const monto = montoEscrito(valor);
  const listo = concepto.trim() && monto && !trabajando;

  const llamar = async (preview) => {
    setTrabajando(true);
    setError("");
    const res = await sendCierrePendingItemNotice(token, mantisBusinessId, clientCode, {
      id: item.id,
      concept: concepto.trim(),
      value: String(monto).replace("-", ""),
      comment: comentario.trim() || undefined,
      to: para,
      file: soporte,
      preview,
    }).catch(() => null);
    setTrabajando(false);
    if (!res?.success) {
      setError(correctionError(res) || "No se pudo preparar el correo.");
      return;
    }
    if (preview) setVista(res.data);
    else onEnviado(res.data);
  };

  return (
    <div className="mt-2 space-y-2 rounded-[8px] border bg-brinks-surface p-2.5 text-[12px]">
      <p className="font-medium text-brinks-foreground">Correo al banco: pedir que cargue la transacción</p>
      <label className="block">
        Concepto
        <input aria-label="Concepto" className={CAMPO} value={concepto} maxLength={200} placeholder="Depósito corriente" onChange={(e) => setConcepto(e.target.value)} />
      </label>
      <label className="block">
        Valor
        <input aria-label="Valor" className={CAMPO} value={valor} onChange={(e) => setValor(e.target.value)} />
      </label>
      <label className="block">
        Soporte del cajero (opcional)
        <input aria-label="Soporte" type="file" className="mt-1 block w-full text-[11.5px]" onChange={(e) => setSoporte(e.target.files?.[0] || null)} />
      </label>
      <label className="block">
        Para (vacío: los destinatarios del cliente)
        <input aria-label="Para" className={CAMPO} value={para} placeholder="correo@bancoagrario.gov.co" onChange={(e) => setPara(e.target.value)} />
      </label>
      <label className="block">
        Comentario (opcional)
        <textarea aria-label="Comentario" className={CAMPO} maxLength={1000} value={comentario} onChange={(e) => setComentario(e.target.value)} />
      </label>
      {error ? <p role="alert" className="text-brinks-danger">{error}</p> : null}
      {vista ? (
        <div className="space-y-1">
          <p className="font-medium">{vista.subject}</p>
          <iframe title="Vista previa del correo" sandbox="" srcDoc={vista.html} className="h-56 w-full rounded-[6px] border bg-white" />
        </div>
      ) : null}
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="outline" disabled={!listo} onClick={() => llamar(true)}>Vista previa</Button>
        <Button size="sm" disabled={!listo} onClick={() => llamar(false)}>
          {trabajando ? <Spinner size="sm" /> : "Enviar al banco"}
        </Button>
        <Button size="sm" variant="outline" disabled={trabajando} onClick={onCancelar}>Cancelar</Button>
      </div>
    </div>
  );
}

export default CorreoTxEnVuelo;
